module.exports = __webpack_public_path__ + "static/media/refresh-disabled.858cfb40.svg";